import { createStyles } from '@mantine/core';

type StyleArgs = {
  isSidePanel?: boolean;
  chatOffset?: number;
};

const useStyles = createStyles(
  (theme, { isSidePanel, chatOffset: chatOffsetProp = 0 }: StyleArgs) => {
    // When chat panel is open, we need to trigger breakpoints earlier
    const chatOffset = chatOffsetProp;

    return {
      dimmedText: {
        color: theme.colors.gray[5],
        ...(isSidePanel
          ? {
              fontSize: theme.fontSizes.xs,
            }
          : {
              [`@media (max-width: ${theme.breakpoints.xs + chatOffset - 1}px)`]: {
                fontSize: theme.fontSizes.xs,
              },
            }),
      },
      contestInfo: {
        ...(isSidePanel
          ? {}
          : {
              [`@media (min-width: ${theme.breakpoints.xs + chatOffset}px)`]: {
                transitionDuration: '.35s',
                transitionTimingFunction: 'linear',
                transitionProperty: 'font-size',
              },
            }),
      },
      flex: {
        display: 'flex',
        gap: theme.spacing.sm / 2,
        ...(isSidePanel
          ? {
              flexDirection: 'column',
              gap: 0,
            }
          : {
              [`@media (max-width: ${theme.breakpoints.xs + chatOffset - 1}px)`]: {
                flexDirection: 'column',
                gap: 0,
              },
            }),
      },
      subHeader: {
        alignItems: 'center',
        display: 'flex',
        opacity: 1,
        transitionDuration: '.35s',
        transitionTimingFunction: 'linear',
        transitionProperty: 'opacity',
      },
      button: {
        minWidth: 100,
      },
      action: {
        minWidth: 'max-content',
      },
      edit: {
        position: 'absolute',
        right: 0,
        top: 0,
        fontWeight: 'bold',
        zIndex: 2,

        '&:hover': {
          background: 'transparent',
        },
      },
      titleContainer: {
        maxWidth: '100%',
      },
    };
  }
);

export default useStyles;
